// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthWrapper_wrapper__hympI","employeeLoginButton":"AuthWrapper_employeeLoginButton__GfMAM"};